module.exports = __webpack_public_path__ + "static/media/GreatSouthernHerald-devicecomp-min@2x.ab55f4b4.webp";